import { createContext, useContext } from 'react'

/**
 * When SimpleGrid cannot slice its React children (the skin passes one `map`
 * child that expands into cards), the mapper reads this limit and only
 * renders that many items (FP-4278).
 */
const GridCollapseContext = createContext<number | null>(null)

export const GridCollapseProvider = GridCollapseContext.Provider

export const useGridCollapseLimit = (): number | null =>
  useContext(GridCollapseContext)
